import React from 'react';
import Banner from '../Banner';
import './style.scss';

const Banner285x366 = () => (
	<Banner width={285} height={366} placeholder={<>Рекламный баннер<br /><br />285х366<br />(сквозной)</>} />
);

export default Banner285x366;
